interface Props {
    title: string;
}

function PageDivider({title}: Props) {

    return (
        <div className="nbis3-divder__container">
            <span className="nbis3-divder__text">
                {title}
            </span>
        </div>
    );
}

export default PageDivider;
